import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faMapMarker } from "@fortawesome/free-solid-svg-icons";
import { Popconfirm } from "antd";
import filterTypes from "data/filter-types";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { search, finish } from "actions/trip-active/actions";
import MapPosition from "../trip-active/map-position";

const UserBikeTripActive = ({
                              userId,
                              list,
                              search,
                              finish,
                              ...rest
                            }) => {
  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const handleFinish = id => {
    finish(id);
  };

  useEffect(() => {
    search(0, 1000, "start,DESC", [{
      fieldName: "user",
      fieldValue: userId,
      searchOperation: filterTypes.EQUALS.value
    }]);
  }, [search, userId]);

  return (
    <div>
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Bike</th>
            <th>Scan</th>
            <th>Start (Position)</th>
            <th>End (Position)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {((list && list.content) || []).map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                  <Link to={`/bikes/${item.bike}`}>
                    {item.bike}
                  </Link>
                </td>
                <td>
                  {moment(item.scan).format("HH:mm YYYY-MM-DD")}
                </td>
                <td>
                  {moment(item.start).format("HH:mm YYYY-MM-DD")}{" "}
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleOpenMap(item.startPosition)}
                    title="Start position"
                  >
                    <FontAwesomeIcon icon={faMapMarker}/>
                  </button>
                </td>
                <td>
                  {item.end ? (
                    <React.Fragment>
                      {moment(item.end)
                        .format("HH:mm YYYY-MM-DD")}{" "}
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleOpenMap(item.endPosition)}
                        title="End position"
                      >
                        <FontAwesomeIcon icon={faMapMarker}/>
                      </button>
                    </React.Fragment>
                  ) : "No Date"}
                </td>
                <td>
                  <Popconfirm
                    title="Are you sure you want to finish this trip?"
                    onConfirm={() => handleFinish(item.id)}
                    placement="top"
                    okText="Yes"
                    cancelText="Cancel"
                  >
                    <button
                      className="btn btn-sm btn-warning"
                      title="Finish"
                    >
                      <FontAwesomeIcon icon={faCheckSquare}/>
                    </button>
                  </Popconfirm>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.tripActive.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finish: bindActionCreators(finish, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserBikeTripActive);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-bike-trip-active.js